/**
     * @desc 7上架我的用户盲盒，先调合约并将orderHash传入
用于：个人盲盒列表页，如果数量小于已有盲盒数量，将拆分该用户盲盒
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/uploadMyUserBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/uploadMyUserBox', params);
}
